module.exports = __webpack_public_path__ + "static/media/birds-lineup-01.93f6f3e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/birds-lineup-01.png
// module id = 243
// module chunks = 1